import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getApiUrl, BASE_URL } from "../utils/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";

const AddNewproduct = () => {
  const UserId = "66abc123def4567890abcd12";
  const navigate = useNavigate();
  const location = useLocation();
  const productToEdit = location.state?.product;

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [sizeCharts, setSizeCharts] = useState([]);

 
  const formik = useFormik({
    initialValues: {
      productName: productToEdit?.productName || "",
      category: productToEdit?.categoryId?._id || "",
      subcategory: productToEdit?.subcategoryId?._id || "",
      sizechart: productToEdit?.sizeChartId?._id || "",
      price: productToEdit?.price || "",
      originalPrice: productToEdit?.originalPrice || "",
      discount: productToEdit?.discount || 0,
      description: productToEdit?.description || "",
      mainImage: null,
      extraImages: [],
      sizes: productToEdit?.sizes || {
        S: 0,
        M: 0,
        L: 0,
        XL: 0,
        XXL: 0,
        "3XL": 0,
        "4XL": 0,
      },
    },
    enableReinitialize: true, 
    validationSchema: Yup.object({
      productName: Yup.string().required("Product Name is required"),
      category: Yup.string().required("Category is required"),
      subcategory: Yup.string().required("Sub Category is required"),
      sizechart: Yup.string().required("Size Chart is required"),
      price: Yup.number().required("Price is required"),
      originalPrice: Yup.number().required("Original Price is required"),
      description: Yup.string().required("Description is required"),
      mainImage: Yup.mixed().nullable(),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const totalProducts = Object.values(values.sizes || {}).reduce(
          (a, b) => a + Number(b),
          0
        );

        const formData = new FormData();
        formData.append("productName", values.productName);
        formData.append("categoryId", values.category);
        formData.append("subcategoryId", values.subcategory);
        formData.append("sizeChartId", values.sizechart);
        formData.append("price", values.price);
        formData.append("originalPrice", values.originalPrice);
        formData.append("discount", values.discount || 0);
        formData.append("description", values.description);
        formData.append("totalProducts", totalProducts);
        formData.append("userid", UserId);
        formData.append("sizes", JSON.stringify(values.sizes || {}));

        if (values.mainImage) {
          formData.append("mainImage", values.mainImage);
        }

        if (values.extraImages && values.extraImages.length > 0) {
          values.extraImages.forEach((file) =>
            formData.append("extraImages", file)
          );
        }

        if (productToEdit) {
          formData.append("productid", productToEdit._id);
        }

        const apiUrl = productToEdit
          ? getApiUrl("update-product")
          : getApiUrl("add-product");

        const res = await fetch(apiUrl, { method: "POST", body: formData });
        const result = await res.json();

        if (result.success) {
          toast.success(
            productToEdit
              ? "🎉 Product Updated Successfully!"
              : "🎉 Product Added Successfully!"
          );
          resetForm();
          navigate("/bsk-secure-admin/product-list");
        } else {
          toast.error(result.message || "❌ Something went wrong");
        }
      } catch (error) {
        toast.error("❌ Something went wrong");
        console.error(error);
      }
    },
  });

  // ---------------- Handle Images ----------------
  const handleMainImage = (e) => {
    formik.setFieldValue("mainImage", e.target.files[0]);
  };

  const handleExtraImages = (e) => {
    formik.setFieldValue("extraImages", Array.from(e.target.files));
  };

  // ---------------- Calculate Discount ----------------
  const handlePriceChange = (e) => {
    const { name, value } = e.target;
    formik.setFieldValue(name, value);

    const price = name === "price" ? value : formik.values.price;
    const originalPrice =
      name === "originalPrice" ? value : formik.values.originalPrice;

    if (price && originalPrice && originalPrice > 0) {
      const discount = Math.round(
        ((originalPrice - price) / originalPrice) * 100
      );
      formik.setFieldValue("discount", discount);
    }
  };

  const totalProducts = Object.values(formik.values.sizes).reduce(
    (a, b) => a + Number(b),
    0
  );

  // ---------------- Fetch Data ----------------
  useEffect(() => {
    fetchCategories();
    fetchSubcategories();
    fetchSizeCharts();
  }, []);

  const fetchCategories = async () => {
    const res = await fetch(getApiUrl("category-list"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userid: UserId }),
    });
    const result = await res.json();
    if (result.success) setCategories(result.data);
  };

  const fetchSubcategories = async (categoryId) => {
    if (!categoryId) {
      setSubcategories([]);
      return;
    }

    const res = await fetch(getApiUrl("subcategory-product-list"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userid: UserId, categoryid: categoryId }),
    });

    const result = await res.json();
    if (result.success) setSubcategories(result.data);
  };
  useEffect(() => {
    if (formik.values.category) {
      fetchSubcategories(formik.values.category);
    } else {
      setSubcategories([]);
    }
  }, [formik.values.category]);
  useEffect(() => {
  if (formik.values.subcategory && !productToEdit) {
    generateProductName(formik.values.subcategory);
  }
}, [formik.values.subcategory]);


  const fetchSizeCharts = async () => {
    const res = await fetch(getApiUrl("getCharts"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userid: UserId }),
    });
    const result = await res.json();
    if (result.success) setSizeCharts(result.data);
  };

  const generateProductName = async (subcategoryId) => {
  const res = await fetch(getApiUrl("product-count-by-subcategory"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ subcategoryId }),
  });

  const result = await res.json();

  if (result.success) {
    const sub = subcategories.find((s) => s._id === subcategoryId);
    if (!sub) return;

    const nextNumber = String(result.count + 1).padStart(2, "0");
    const autoName = `${sub.name} ${nextNumber}`;

    formik.setFieldValue("productName", autoName);
  }
};


  return (
    <div className="container" style={{ maxWidth: "1000px" }}>
      <ToastContainer position="top-right" autoClose={5000} />
      <h2 className="text-center my-4 fw-bold">
        {productToEdit ? "Edit Product" : "Add New Product"}
      </h2>

      <form onSubmit={formik.handleSubmit} className="add-product-form">
        <div className="d-flex flex-wrap">
          
          <div className="floating-label-group col-md-6 col-12">
            <input
              type="text"
              name="productName"
              placeholder="Product Name*"
              className="form-control"
              value={formik.values.productName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              required
            />
            <label>Product Name</label>
          </div>

          
          <div className="floating-label-group col-md-6 col-12">
            <select
              name="category"
              value={formik.values.category}
              onChange={formik.handleChange}
              className="form-select"
              required
            >
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>

          
          <div className="floating-label-group col-md-6 col-12">
            <select
              name="subcategory"
              value={formik.values.subcategory}
              onChange={formik.handleChange}
              className="form-select"
              required
            >
              <option value="">Select Subcategory</option>
              {subcategories.map((sub) => (
                <option key={sub._id} value={sub._id}>
                  {sub.name}
                </option>
              ))}
            </select>
          </div>

          {/* Size Chart */}
          <div className="floating-label-group col-md-6 col-12">
            <select
              name="sizechart"
              value={formik.values.sizechart}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="form-select"
              required
            >
              <option value="">Select Size Chart</option>
              {sizeCharts.map((chart) => (
                <option key={chart._id} value={chart._id}>
                  {chart.chartName}
                </option>
              ))}
            </select>
          </div>

          {/* Sizes */}
          {Object.keys(formik.values.sizes).map((size) => (
            <div className="floating-label-group col-md-3 col-6" key={size}>
              <input
                type="number"
                name={`sizes.${size}`}
                placeholder=" "
                value={formik.values.sizes[size]}
                onChange={formik.handleChange}
              />
              <label>{size}</label>
            </div>
          ))}

          
          <div className="floating-label-group col-md-6 col-12">
            <input
              type="number"
              name="price"
              placeholder=" "
              value={formik.values.price}
              onChange={handlePriceChange}
            />
            <label>Price</label>
          </div>

         
          <div className="floating-label-group col-md-6 col-12">
            <input
              type="number"
              name="originalPrice"
              placeholder=" "
              value={formik.values.originalPrice}
              onChange={handlePriceChange}
            />
            <label>Original Price</label>
          </div>

          <div className="floating-label-group col-md-6 col-12">
            <input
              type="number"
              name="discount"
              placeholder=" "
              value={formik.values.discount}
              readOnly
            />
            <label>Discount %</label>
          </div>

          {/* Description */}
          <div className="floating-label-group col-12">
            <textarea
              name="description"
              placeholder=" "
              className="form-control"
              rows={3}
              value={formik.values.description}
              onChange={formik.handleChange}
            />
            <label>Description</label>
          </div>

          {/* Main Image */}
          <div className="col-md-6 col-12 mb-3">
            <label className="fw-bold mb-2">Main Image</label>
            <input
              type="file"
              className="form-control"
              onChange={handleMainImage}
            />
            {productToEdit?.mainImage && !formik.values.mainImage && (
              <img
                src={`${BASE_URL}${productToEdit.mainImage}`}
                alt="main"
                width="120"
                className="rounded mb-2 border"
              />
            )}
          </div>

          {/* Extra Images */}
          <div className="col-md-6 col-12 mb-3">
            <label className="fw-bold mb-2">Extra Images</label>
            <input
              type="file"
              className="form-control"
              multiple
              onChange={handleExtraImages}
            />
            {productToEdit?.extraImages?.length > 0 &&
              formik.values.extraImages.length === 0 && (
                <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
                  {productToEdit.extraImages.map((img, i) => (
                    <img
                      key={i}
                      src={`${BASE_URL}${img}`}
                      alt={`extra-${i}`}
                      width="80"
                      className="rounded border"
                    />
                  ))}
                </div>
              )}
          </div>

          <div className="col-12 text-center my-3">
            <h5>Total Qty: {totalProducts}</h5>
          </div>

          <div className="col-12 text-center">
            <button
              type="submit"
              className={
                formik.isValid && formik.dirty
                  ? "btn btn-primary px-4 py-2"
                  : "btn btn-success px-4 py-2"
              }
              disabled={!formik.isValid || !formik.dirty}
            >
              {productToEdit ? "Update Product" : "Add Product"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddNewproduct;
